import CryptoJS from 'crypto-js'
// CBC
export default {
    // 加密
    encrypt(txt) {
        var key = CryptoJS.enc.Utf8.parse('wenxiang21_great')
        var srcs = CryptoJS.enc.Utf8.parse(txt)
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return encrypted.toString()
    }
    // encrypt(word, keyStr, ivStr) {
    //     keyStr = keyStr ? keyStr : "wenxiang21_great";
    //     ivStr = ivStr ? ivStr : "wenxiang21_great";
    //     let key = CryptoJS.enc.Utf8.parse(keyStr);
    //     let iv = CryptoJS.enc.Utf8.parse(ivStr);
    //     let srcs = CryptoJS.enc.Utf8.parse(word);

    //     let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    //         iv,
    //         mode: CryptoJS.mode.CBC,
    //         padding: CryptoJS.pad.ZeroPadding
    //     });
    //     return encrypted.toString();
    // },
    // 解密
    // decrypt(word, keyStr, ivStr) {
    //     keyStr = keyStr ? keyStr : "wenxiang21_great";
    //     ivStr = ivStr ? ivStr : "wenxiang21_great";
    //     var key = CryptoJS.enc.Utf8.parse(keyStr);
    //     let iv = CryptoJS.enc.Utf8.parse(ivStr);

    //     var decrypt = CryptoJS.AES.decrypt(word, key, {
    //         iv,
    //         mode: CryptoJS.mode.CBC,
    //         padding: CryptoJS.pad.ZeroPadding
    //     });
    //     return decrypt.toString(CryptoJS.enc.Utf8);
    // }
}


// WEBPACK FOOTER //
// ./src/utils/AES.js